import React, {} from 'react';
import footerGraphic from '../../Assets/footer.svg'
import uwmLogo from '../../Assets/logo-uwm.png'
import rokLogo from '../../Assets/logo-rok.png'
import wydzialLogo from '../../Assets/logo-wydzial.svg'
import styled from "styled-components";


const Footer = () => {

    return (
        <Wrapper>
            <LogoDisplay>
                <img src={uwmLogo} alt={'logo'}/>
                <img src={wydzialLogo} alt={'logo'}/>
                <img src={rokLogo} alt={'logo'}/>

            </LogoDisplay>
            <Signatures>
                <Pair>
                    <h3>Kontakt</h3>
                    <a href="mailto:550poster@uwm.edu.pl">550poster@uwm.edu.pl</a>
                </Pair>
                <Pair>
                    <h3>Design</h3>
                    <a href="http://www.bujny.com">bujny.com</a>
                </Pair>
                <Pair>
                    <h3>Code</h3>
                    <a href="http://www.rogalo.dev">rogalo.dev</a>
                </Pair>
            </Signatures>

            <img src={footerGraphic} alt={'Graphic Footer'}/>
        </Wrapper>
    )
}

export default Footer;


const Wrapper = styled.div`
  width: 100vw;

  img {
    width: 100%;
  }
`

const Signatures = styled.div`
  width: 40%;
  position: relative;
  top: 200px;
  left: 10%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  h3 {
    font-family: Lato;
    font-weight: 600;
    font-size: 14px;
    line-height: 1.5;
    color: black;
    text-decoration: underline;
    margin: 0;
    padding: 0;
  }
  p, a {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5;
    color: black;
    margin: 0;
    padding: 0;
    text-decoration: none;
  }
  
  a: hover{
    opacity: 0.5;
  }
`


const Pair = styled.div`
  display: flex;
  flex-direction: column`


const LogoDisplay = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-evenly;
  margin: 0;
  padding: 0;

  img {
    width: 20%;
    height: 20%;
    margin: 0;
    padding: 0;

    @media (max-width: 800px) {
      width: 50%;
      height: 50%;
      margin: 10px;
    }
  }
`

